export enum DisputeStatusEnum {
    Pending,
    Approved,
    Rejected
}
